// extracted by mini-css-extract-plugin
export default {"brandLogo":"brandLogo__b73J-"};